export default __webpack_public_path__ + "static/media/musiswap-chart-header.b1b21046.png";